exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../fonts/Inter-Medium.woff2"));
var ___CSS_LOADER_URL___1___ = getUrl(require("../fonts/Inter-Medium.woff"));
// Module
exports.push([module.id, "@font-face {\n    font-family: 'Inter-Medium';\n    src: url(" + ___CSS_LOADER_URL___0___ + ") format('woff2'), url(" + ___CSS_LOADER_URL___1___ + ") format('woff');\n    font-weight: 500;\n    font-style: normal;\n}\n", ""]);
